module.exports = __webpack_public_path__ + "static/media/icon-envelope-blue.f7245538.svg";